/**
 * @file コンポーネント：サイドメニュー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { SearchCategory } from "~/src/components/projects/SearchCategory";
import { SearchDepartment } from "~/src/components/projects/SearchDepartment";
import { SearchFilter } from "~/src/components/projects/SearchFilter";
import { SearchKeyword } from "~/src/components/projects/SearchKeyword";
import { SearchSection } from "~/src/components/projects/SearchSection";
import { SearchSurgeon } from "~/src/components/projects/SearchSurgeon";

// 関数読み込み
import {
    getDepartmentPath,
} from "~/src/functions/common";

// スタイル読み込み
import {
    StyledSidemenu,
    StyledSidemenuHeadline,
    StyledForm,
    StyledFormDepartment,
    StyledFormDepartmentSelect,
    StyledFormDepartmentSelectOption,
    StyledSidemenuLinkButton,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledSidemenu
            className={[
                props.isOpenSidemenu && "is-open",
                props.isVideo && "is-video",
            ]}
        >
            {/* 検索メニュー見出し（非表示） */}
            <StyledSidemenuHeadline>
                {localized["Label.SearchContent"]}
            </StyledSidemenuHeadline>
            {/* 診療科プルダウン */}
            {props.departmentlist !== null &&
                props.departmentlist.length > 0 && (
                    <SearchSection
                        contents={[
                            <StyledForm>
                                <StyledFormDepartment>
                                    <StyledFormDepartmentSelect
                                        defaultValue={getDepartmentPath()}
                                        onChange={(e) =>
                                            props.fnOnChangeSelectDepartment(e)
                                        }
                                    >
                                    {props.departmentlist.map(
                                        (department, index) => (
                                            <StyledFormDepartmentSelectOption
                                                key={"option-" + index}
                                                value={department.link}
                                            >
                                                {department.name}
                                            </StyledFormDepartmentSelectOption>
                                        )
                                    )}
                                    </StyledFormDepartmentSelect>
                                </StyledFormDepartment>
                            </StyledForm>,
                        ]}
                        headline={localized["Label.SearchDepartment"]}
                    />
                )}
            {/* 絞り込み中のみ表示する */}
            {props.isShowSearchFilter === true &&
                (props.keywordString !== "" ||
                    props.surgeonString !== "" ||
                    props.tagString !== "" ||
                    props.typeString !== "") && (
                    // 検索フィルター
                    <SearchSection
                        contents={[
                            <SearchFilter
                                direction="column"
                                key="filter"
                                keywordString={props.keywordString}
                                onColor="sub"
                                operationNameString={props.operationNameString}
                                surgeonlist={props.surgeonlist}
                                surgeonString={props.surgeonString}
                                tagString={props.tagString}
                                typeString={props.typeString}
                            />,
                        ]}
                        headline={localized["Label.SearchFilter"]}
                    />
                )}
            {/* 検索キーワード絞り込み */}
            <SearchSection
                contents={[
                    <SearchKeyword
                        key="keyword"
                        placeholder={localized["Label.KeywordPlaceholder"]}
                        urlSearchAction={props.urlSearchAction}
                    />,
                ]}
                headline={localized["Label.Keyword"]}
            />
            {/* 検索カテゴリー絞り込み */}
            <SearchSection
                contents={[
                    <SearchCategory
                        categorylist={props.selectedCategorylist}
                        key="category"
                    />,
                ]}
                headline={localized["Label.Category"]}
            />
            {/* 検索執刀医絞り込み */}
            <SearchSection
                contents={[
                    <SearchSurgeon
                        key="surgeon"
                        surgeonlist={props.selectedSurgoenlist}
                    />,
                ]}
                headline={localized["Label.Surgeon"]}
            />
            {/* 会社概要 */}
            <StyledSidemenuLinkButton
                className="with-divider"
                href={props.linkAboutCompany}
                target="_blank"
            >
                {localized["Label.AboutCompany"]}
            </StyledSidemenuLinkButton>
            {/* 利用規約 */}
            <StyledSidemenuLinkButton
                href={props.linkTerms}
            >
                {localized["Label.Terms"]}
            </StyledSidemenuLinkButton>
            {/* プライバシーポリシー */}
            <StyledSidemenuLinkButton
                href={props.linkPrivacypolicy}
                target="_blank"
            >
                {localized["Label.PrivacyPolicy"]}
            </StyledSidemenuLinkButton>
            {/* 推奨環境 */}
            <StyledSidemenuLinkButton
                href="/accessibility"
            >
                {localized["Label.Accessibility"]}
            </StyledSidemenuLinkButton>
            {/* 特定商取引法に基づく表記 */}
            <StyledSidemenuLinkButton
                href={props.linkSpecifiedCommercialTransactionAct}
                target="_blank"
            >
                {localized["Label.SpecifiedCommercialTransactionAct"]}
            </StyledSidemenuLinkButton>
            {/* ヘルプ */}
            <StyledSidemenuLinkButton
                href={props.linkHelp}
                target="_blank"
            >
                {localized["Label.Help"]}
            </StyledSidemenuLinkButton>
            {/* お問い合わせ */}
            <StyledSidemenuLinkButton
                href="https://share.hsforms.com/1UJHSQWohTBeeS39vdvcNzAclqdg"
                target="_blank"
            >
                {localized["Label.Contact"]}
            </StyledSidemenuLinkButton>
        </StyledSidemenu>
    );
};
